import React, { Component } from 'react';
import './Heading.css';
import PropTypes from 'prop-types';
import CustomLink from "../../components/CustomLink";

// IE detect
let isIE = false;
if (typeof (document) !== 'undefined') {
  isIE = false || !!document.documentMode;
}

const nameSize = (size) => {
  let nameSize = 24 / size.length;
  // 1.286 = min-font-size in rem
  if (nameSize < 1.286) {
    return 1.286 + 'rem';
  } else {
    return nameSize + 'rem';
  }
}

class Heading extends Component {
  static contextTypes = {
    width: PropTypes.number
  };

  render() {
    return (
      <div className="HeadingContainer">
        <div className='HeadingContainerText'>
          <p>Развиваем цифровую инфраструктуру для жизни <span>вместе</span></p>
          <CustomLink content="Вакансии" to="/vacancies" style={{color: 'black'}}/>
        </div>
        <img src={require('./img/erth.png')}/>
      </div>
    );
  }
}

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading/index.js